import type { BoxProps } from '@mui/material/Box';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

type FormSocialsProps = BoxProps & {
  signInWithGoogle?: () => void;
  signInWithFacebook?: () => void;
};

export function FormSocials({
  sx,
  signInWithGoogle,
  signInWithFacebook,
  ...other
}: FormSocialsProps) {
  return (
    <Box
      sx={[
        {
          gap: 1.5,
          display: 'flex',
          justifyContent: 'center',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      {signInWithGoogle && (
        <IconButton color="inherit" onClick={signInWithGoogle}>
          <Iconify width={22} icon="socials:google" />
        </IconButton>
      )}

      {signInWithFacebook && (
        <IconButton color="inherit" onClick={signInWithFacebook}>
          <Iconify width={22} icon="socials:facebook" />
        </IconButton>
      )}
    </Box>
  );
}
